<template>
    <v-card class="audit-card">
        <v-row>
            <v-col cols="11" class="ma-auto">
                <v-card-title class="ma-0 pa-0">
                    <h5 class="pl-4">Documents liés</h5>
                </v-card-title>
            </v-col>

            <!-- <v-spacer></v-spacer> -->

            <v-col cols="1" class="d-flex align-center px-0 justify-center">
                <v-row>
                    <v-col cols="6" />

                    <v-col cols="6" class="align-center pa-0">
                        <v-btn-icon
                            :icon="documentsExpand ? '$fa-chevron-up' : '$fa-chevron-down'"
                            data-cy="AuditConnectedAcrDocuments-documents"
                            @click="documentsExpand = !documentsExpand"
                            style="width: 40px"
                            class="d-inline px-2"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <!-- <p>enfant loading : {{loading}}</p> -->

        <v-card-text v-if="documentsExpand" transition="expand">
            <v-row class="pt-6">
                <v-col class="py-0">
                    <!-- <p>documentsHeaders : {{documentsHeaders}}</p> -->
                    <!-- <p>enfant documentsExpand : {{documentsExpand}}</p> -->
                    <!-- <p>localConnectedDocuments : {{localConnectedDocuments}}</p> -->
                    <v-data-table
                        :headers="documentsHeaders"
                        :items="localConnectedDocuments"
                        class="table mt-3"
                        fixed-header
                        :items-per-page="-1"
                    >
                        <template v-slot:item="props">
                            <tr @click.stop="openDocument(props.item.id)" style="cursor: pointer">
                                <td>
                                    <!-- // ** sort don't work properly : calculated on -->
                                    <!-- // ** "name", sometimes empty -->
                                    <!-- // ** "type" is different from $t("document.shortType." + props.item.type -->
                                    <h3 v-if="props.item.name" class="pl-6">
                                        {{ props.item.name }}
                                    </h3>
                                    <h3
                                        v-else-if="
                                            props.item.accountingLines &&
                                            props.item.accountingLines[0] &&
                                            props.item.accountingLines[0].wording
                                        "
                                        class="pl-6"
                                    >
                                        {{ props.item.accountingLines[0].wording }}
                                    </h3>

                                    <h3 v-else-if="props.item.thirdPartyCompany" class="pl-6">
                                        {{ props.item.thirdPartyCompany }}
                                    </h3>
                                </td>
                                <td class="pl-3 text-center">
                                    {{ $t("document.shortType." + props.item.type || "UNKNOWN") }}
                                </td>
                                <td class="text-center">
                                    <template v-if="props.item.type === 'MISCELLANEOUS'">
                                        <v-icon color="primary" size="large">$dot</v-icon>
                                    </template>
                                    <v-chip
                                        class="ma-2"
                                        label
                                        :color="statusColor(props.item)"
                                        v-else
                                        size="small"
                                        variant="outlined"
                                    >
                                        {{ statusTooltip(props.item) }}
                                    </v-chip>
                                </td>
                                <!-- deactived temporarily 
                                <td class="text-right">
                                    <v-icon
                                        size="small"
                                        class="text-primary"
                                        @click.stop="unlinkDocument(props.item.id)"
                                        >$fa-unlink</v-icon
                                    >
                                </td>
                                -->
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
import { cloneDeep } from "lodash";

import Document from "../document/DocumentRouter.vue";
import DocumentsTable from "../document/DocumentsTable.vue";
import UploadDocuments from "../document/UploadDocuments.vue";

import UPDATE_AUDIT_CHECK_RESULT_CONNECTED_DOCUMENTS from "../../graphql/audit/UpdateAuditCheckResultConnectedDocuments.gql";

import { Component, Prop, Vue, Watch, toNative } from "vue-facing-decorator";

@Component({
    components: {
        UploadDocuments,
        DocumentsTable,
        Document,
    },
    emits: ["showLinkedDocument", "unlinkedDocument", "upsertedAuditCheckResult"],
})
export class AuditConnectedAcrDocuments extends Vue {
    //+
    // @Prop({ default: false }) documentsExpand: boolean;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: null }) connectedDocuments: Array<any>;
    @Prop({ default: "" }) acKey: string;
    @Prop({ default: null }) auditCheckResult: any;
    @Prop({ default: "" }) accountingPeriodId: string;

    // @Prop({ default: "" }) companyId: string
    // @Prop({ default: false }) value: boolean
    // @Prop({ default: null }) documentToDisplay: any
    // @Prop({ default: null }) documents: any

    @Watch("connectedDocuments", { immediate: true, deep: true })
    onConnectedDocumentsChanged() {
        this.localConnectedDocuments = cloneDeep(this.connectedDocuments);
    }

    // + START
    // ** sort don't work properly : calculated on
    // ** "name", sometimes empty
    // ** "type" is different from $t("document.shortType." + props.item.type
    documentsHeaders = [
        { title: "Nom", value: "name", align: "start", class: "pl-8", sortable: true },
        // { title: 'Compte Comptable', value: 'accountableAccount', align: 'start' },
        { title: "Type", value: "type", align: "center", sortable: true },
        { title: "Statut", value: "status", align: "center", sortable: true },
        //{ title: "Action", value: "action", align: "end", sortable: true },
    ];

    localConnectedDocuments: Array<any> = [];

    dialogAuditCheckDocumentsManager: boolean = false;

    documentsExpand: boolean = false;

    // displayLinkedDocument(document) {
    //     debugger
    //     this.dialogAuditCheckDocumentsManager = true
    //     // this.documentToDisplay = document
    // }

    openDocument(id) {
        this.$emit("showLinkedDocument", id);
    }

    unlinkDocument(id) {
        this.localConnectedDocuments = this.localConnectedDocuments.filter(
            (document) => document.id !== id,
        );
        this.$emit("unlinkedDocument", id);
        this.upsertAuditCheckResult();
    }

    // addNewDocument(data) {
    //     this.localConnectedDocuments.push(data)
    // }

    // validateNewDocuments(data) {
    //     this.createGrossSalaryMatchData()
    // }

    selectDocument(document) {
        this.localConnectedDocuments.push(document);
        // this.createGrossSalaryMatchData()
    }

    // clearDocument() {
    //     this.documentToDisplay = null
    // }

    // replaceList(data) {
    //     this.localConnectedDocuments = data
    //     this.createGrossSalaryMatchData()
    // }

    statusTooltip(item) {
        const status = item.status;
        if (status === "INFORMATION_REQUEST") return item.chatStatus;
        return this.$t("document.status." + status);
    }

    statusColor(document) {
        const status = document.status;
        switch (status) {
            case "PENDING":
            case "DENIED":
            case "DELETED":
            case "ERROR":
                return "error";
            case "INFORMATION_REQUEST":
                return "primary";
            case "ORIGINAL_UPLOADED":
                return "orange";
            case "UPLOADED":
                return "orange";
            case "ANALYSED":
            case "ANALYSED_OK":
                return "primary";
            case "VALIDATED":
                return "secondary";
        }
        return "error";
    }

    async upsertAuditCheckResult() {
        // ++ pass through in Manager

        let connectedDocumentIds: Array<any> = [];

        if (this.localConnectedDocuments?.length) {
            connectedDocumentIds = this.localConnectedDocuments.map((doc) => doc.id);
        }

        if (this.auditCheckResult?.id) {
            const auditCheckResultVariables: any = {
                acrId: this.auditCheckResult?.id,
                connectDocuments: connectedDocumentIds || [],
            };

            if (auditCheckResultVariables) {
                await this.$apollo.mutate({
                    mutation: UPDATE_AUDIT_CHECK_RESULT_CONNECTED_DOCUMENTS,
                    variables: auditCheckResultVariables,
                });
            }

            this.$emit("upsertedAuditCheckResult");
        }

        // ++++++++++++++ RESET +++++++++++++++++++
        // if (this.$apollo.queries && this.$apollo.queries.auditItems) {
        //     this.$apollo.queries.auditItems.refetch();
        // } else {
        //     debugger // git-ignore
        // }
    }
    // + END
}

export default toNative(AuditConnectedAcrDocuments);
</script>
